import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Landing from "./pages/Landing";
import AboutUs from "./pages/AboutUs";
import Intake from "./pages/Intake";
import FAQ from "./pages/FAQ";
import WhoWeAre from "./pages/WhoWeAre";
import Donate from "./pages/Donate";
import Privacy from "./pages/Privacy";
import BusyBees from "./pages/BusyBees";
import Programs from "./pages/Programs";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="page">
        <Header />
        <main className="page-content">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/intake" element={<Intake />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/volunteer/busy-bees" element={<BusyBees />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
